import styled from "styled-components";

export const Div = styled.div`
  width: 650px;
  height: 500px;
  position: absolute;
  z-index: -100;
`;
